<script setup>
import FlexRow from '@/components/shared/page/FlexRow.vue'
import AddressType from '@/components/shared/transform/AddressType.vue'
import {addressTypes} from '@/constants/address-types.js'
import {computed, toRefs} from 'vue'

//Props
const props = defineProps({
  address: {
    type: Object,
    required: true,
  },
  showType: {
    type: Boolean,
    default: false,
  },
})

//Refs
const {address} = toRefs(props)
const type = computed(() => address.value?.addressType)
</script>

<template>
  <FlexRow
    v-if="address"
    :gap="0.25"
  >
    <span :class="$style.addressValue">
      <template v-if="showType && type">
        <AddressType
          :type="type"
          suffix=": "
        />
      </template>
      <template v-if="address.displayValue">
        {{ address.displayValue }}
      </template>

      <template v-else-if="type === addressTypes.SLACK">
        {{ address.slackEmail }}
      </template>
      <template v-else-if="type === addressTypes.TEAMS">
        {{ address.teamsEmail }}
      </template>
      <template v-else-if="type === addressTypes.WHATSAPP">
        {{ address.value?.replace(/whatsapp:/, '') }}
      </template>
      <template v-else>
        {{ address.value }}
      </template>
    </span>
  </FlexRow>
</template>

<style lang="scss" module>
.addressValue {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
